import Vue from 'vue'
import { errorServeiceHandler, makeQueryFormDataDyn, makeQueryStringDync } from '../helper'

const state = {
    profileData: undefined
};

const getters = {
    getprofileData: (state) => {
        return state.profileData;
    }
};

const mutations = {
    setprofileData: (state, data) => {
        state.profileData = data;
    }
};

const actions = {
    actCreatePayment: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log(payload);
            let data = makeQueryFormDataDyn(payload);
            fetch(context.getters.baseUrl + '/lco/v1/payment.php', {
                method: 'POST',
                body: data
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {

                    resolve(data)

                }).catch((error) => {

                    reject(error);
                });
        });
    },
    actPayMobikwik: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log(payload);
            let data = makeQueryFormDataDyn(payload);
            fetch(context.getters.baseUrl + '/lco/v1/payment/wallet', {
                method: 'POST',
                body: data
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {

                    resolve(data)

                }).catch((error) => {

                    console.log("error", error)
                    reject(error);
                });
        });
    },
    actPutProfileUpdate: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            console.log("payload ", payload);
            let data = makeQueryFormDataDyn(payload);
            var object = {};
            data.forEach(function (value, key) {
                object[key] = value;
            });
            data = JSON.stringify(object);

            console.log("data || before send ", data);
            fetch(context.getters.baseUrl + '/lco/v1/lco', {
                method: 'PUT',
                body: data
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    console.log("data", data)

                    resolve(data)

                }).catch((error) => {
                    console.log("error", error)
                    reject(error);
                });
        });
    },
    actPutSubuserProfileUpdate: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            console.log("payload ", payload);
            let data = makeQueryFormDataDyn(payload);

            var object = {};
            data.forEach(function (value, key) {
                object[key] = value;
            });
            data = JSON.stringify(object);

            console.log("data || before send ", data);
            fetch(context.getters.baseUrl + '/lco/v1/subuser/' + payload.subuserid, {
                method: 'PUT',
                body: data
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    console.log("data", data)

                    resolve(data)

                }).catch((error) => {
                    console.log("error", error)
                    reject(error);
                });
        });
    },
    actGetlogout: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            fetch(context.getters.baseUrl + '/lco/v1/logout.php/' + payload.lcoid, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    actGetSubuserlogout: (context, payload) => {
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/subuser/logout', {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    actGetPayments: (context,payload) => {
        return new Promise((resolve, reject) => {
            let queryStr = ''
            queryStr = makeQueryStringDync(payload)
            fetch(context.getters.baseUrl + '/lco/v1/lco/payments' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {

                    resolve(data)


                }).catch((error) => {

                    reject(error);
                });
        });
    },
    actGetLastSubuserId: (context, payload) => {
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/subuser/lastid', {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    actGetSubusers: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            let queryStr = ''
            queryStr = makeQueryStringDync(payload)

            fetch(context.getters.baseUrl + '/lco/v1/subuser' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {

                    resolve(data)

                }).catch((error) => {

                    reject(error);
                });
        });
    },
    actGetSingleSubuser: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            fetch(context.getters.baseUrl + '/lco/v1/subuser/' + payload, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {

                    resolve(data)

                }).catch((error) => {

                    reject(error);
                });
        });
    },
    actPostSubuser: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log(payload);
            let data = makeQueryFormDataDyn(payload);
            fetch(context.getters.baseUrl + '/lco/v1/subuser', {
                method: 'POST',
                body: data
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {

                    resolve(data)

                }).catch((error) => {
                    console.log("error", error)
                    reject(error);
                });
        });
    },
    actPutSubuser: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            console.log(payload);
            let data = makeQueryFormDataDyn(payload);

            var object = {};
            data.forEach(function (value, key) {
                object[key] = value;
            });
            data = JSON.stringify(object);
            fetch(context.getters.baseUrl + '/lco/v1/subuser/' + payload.lcosubuserid, {
                method: 'PUT',
                body: data
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {

                    resolve(data)

                }).catch((error) => {
                    console.log("error", error)
                    reject(error);
                });
        });
    },
    getPaymentStatus: (context, dataObj) => {
        return new Promise((resolve, reject) => {
            let queryStr = makeQueryStringDync(dataObj)
            console.log(queryStr)
            fetch(context.getters.baseUrl + '/lco/v1/paymentstatuscheckapi' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    verifyContact: (context, payload) => {
        return new Promise((resolve, reject) => {
            let data = makeQueryFormDataDyn(payload)
           fetch(context.getters.baseUrl + '/lco/v1/lco/verifycontact', {
                method: 'POST',
                body: data
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()    
           }).then((data) => {
                resolve(data)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    verifyUserContactOTP: (context, payload) => {
        return new Promise((resolve, reject) => {
            let data = makeQueryFormDataDyn(payload)
           fetch(context.getters.baseUrl + '/lco/v1/lco/validateotp', {
                method: 'POST',
                body: data
           })
           .then(errorServeiceHandler)
           .then((response) => {
              return response.json()    
           }).then((data) => {
                resolve(data)
            }).catch((error) => {
                reject(error)
            })
        })
    },
};

export default {
    state, getters, mutations, actions
};



// WEBPACK FOOTER //
// ./src/store/modules/headerModule.js